import { legacyAnthropicThinkingModelId } from './reasoningModelCanonical';

function openAiUsesExclusiveReasoningApi(modelName: string): boolean {
  const m = modelName.toLowerCase();
  return m.startsWith('o1') || m.startsWith('o3-mini');
}

const uiSystemToApiCompany: Record<string, string> = {
  OpenAI: 'openAi',
  anthropicAi: 'anthropic',
};

export function getCommandTextReasoningLockedOn(
  aiSystemUi: string,
  modelName: string,
): boolean {
  const apiCo = uiSystemToApiCompany[aiSystemUi];
  if (apiCo === 'openAi') {
    return openAiUsesExclusiveReasoningApi(modelName);
  }
  if (apiCo === 'anthropic') {
    return !!legacyAnthropicThinkingModelId(modelName);
  }
  return false;
}
